import { Ifilter } from "../filter"

export interface IRazonModeloDTO {
    razonId: string
    equipoModeloId: string
    codigo: string
    nombre: string
    tipoEquipo: string
    tipoEquipoId: string
    equipoAuxiliar: boolean
    numeracion: number
}

export const initialRazonModeloDTO = {
    razonId: "",
    equipoModeloId: "",
    codigo: "",
    nombre: "",
    tipoEquipo: "",
    tipoEquipoId: "",
    equipoAuxiliar: false,
    numeracion: 0
}

export interface IRazonModeloCommandCreate {
    equipoModeloId: string
    razonId: string
}

export const initialRazonModeloCommandCreate = {
    equipoModeloId: "",
    razonId: ""
}

export interface IRazonModeloRequest extends Ifilter {
    nombre?: string
    razonId?: string
    tipoEquipoId?: string | null
}

export const initialRazonModeloRequest = {
    skip: 0,
    take: 50,
    search: "",
};

export interface IRazonModeloCommandEliminar {
    modeloId?: string
    razonId?: string
    nombre?: string;
}